"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bls12_381_G2_element_uncompress = exports.bls12_381_G2_element_compress = exports.bls12_381_G2_element_hashToGroup = exports.bls12_381_G2_element_eq = exports.bls12_381_G2_element_scalarMul = exports.bls12_381_G2_element_neg = exports.bls12_381_G2_element_add = void 0;
var types_1 = require("../../../type_system/types.js");
var IRNative_1 = require("../../../../IR/IRNodes/IRNative/index.js");
var Term_1 = require("../../../Term/index.js");
var addApplications_1 = require("../addApplications.js");
exports.bls12_381_G2_element_add = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.blsG2, types_1.blsG2], types_1.blsG2), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_add;
}));
exports.bls12_381_G2_element_neg = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.blsG2], types_1.blsG2), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_neg;
}));
exports.bls12_381_G2_element_scalarMul = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.int, types_1.blsG2], types_1.blsG2), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_scalarMul;
}));
exports.bls12_381_G2_element_eq = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.blsG2, types_1.blsG2], types_1.bool), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_equal;
}));
exports.bls12_381_G2_element_hashToGroup = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.bs, types_1.bs], types_1.blsG2), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_hashToGroup;
}));
exports.bls12_381_G2_element_compress = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.blsG2], types_1.bs), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_compress;
}));
exports.bls12_381_G2_element_uncompress = (0, addApplications_1.addApplications)(new Term_1.Term((0, types_1.fn)([types_1.bs], types_1.blsG2), function (_dbn) {
    return IRNative_1.IRNative.bls12_381_G2_uncompress;
}));
